import React from 'react'
import { FormGroup, Row, Col } from 'react-bootstrap'
import { ValidationError, Button, Label } from 'fw/components'
import { Form, TextBox } from 'fw/forms'
import { Link } from 'react-router-dom'
import News from './News'
import * as API from 'modules/app/API'
import * as App from 'modules/app/App'
import * as Block from 'fw/globals/Block'
import * as FW from 'fw/system/FW'

class CompleteLogin extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = () => {

        const rm = {
            login: "",
        }

        return {
            error: null,
            listNews: "",
            showNews: FW.getSettings().showNews,
            version: FW.getSettings().version,
            form: {
                login: rm.login,
                password: ""
            }
        }
    }

    signIn = (e) => {
        const rq = {
            login: localStorage.getItem('login'),
            password: this.state.form.password,
			// Value is preceded with minus because offset is UTC - Client Time Zone Offset
			clientTimeZoneOffset: - new Date().getTimezoneOffset()/60
        }

        // Spinner
        this.setState({ error: null })

        API.Core.post('/security/authentication/completeLogin', rq,
            {
                success: (sr) => {
                    // Load app state
                    App.login(sr.data);

                    // Redirect to landing page
                    if (sr.data.landingPage)
                        this.props.history.push(sr.data.landingPage);
                    else
                        this.props.history.push('/');
                },
                error: (sr) => {
                    this.setState({ error: sr.error })
                },
                exception: (err) => {
                    this.setState({
                        error: { errorMessage: "Oops! Something went wrong. Please contact administrator." }
                    });
                }
            });
    }

    onChange = (form) => {
        this.setState({ form });
    }

    componentDidMount() {
        // Set focus
        this.passwordTextBox.focus();

        // Get news
        API.Core.get('/app/query/getNews', null,
            {
                success: (sr) => {
                    this.setState({ listNews: sr.data });
                },
                exception: (sr) => {
                    console.error("Error reading news.", sr);
                }
            },
            {
                block: false
            });
    }

    renderNews() {
        if (this.state.showNews && this.state.listNews.length > 0) {
            return (
                <div className="pull-left">
                    <News content={this.state.listNews} />
                </div>
            )
        }
        else
            return (<div className="pull-left"> <News content={""} /></div>)
    }

    render() {
        return (
            <React.Fragment>
                <ValidationError error={this.state.error} />
                <Block.Block ref={Block.hookref}>
                    <Row>
                        <Col sm={6}>
                            {this.renderNews()}
                        </Col>
                        <Col sm={6}>
                            <p className="login-box-heading">Sign in to start your session</p>
                            <Form
                                onSubmit={this.signIn}
                                values={this.state.form}
                                onChange={this.onChange}>
                                <FormGroup>
                                    {/* <div className="pull-left">
                                        <a href="/public/login" title="Go back">
                                            <FontAwesomeIcon icon={faArrowCircleLeft} size="2x" style={{ color: '#2A77E4' }} />
                                        </a>
                                    </div> */}
                                    <Label>&nbsp;&nbsp;&nbsp;Password</Label>
                                </FormGroup>
                                <FormGroup>
                                    <input type={"password"} name={"password"} autoComplete="password" style={{ display: "none" }} />
                                    <TextBox 
                                        name="password" 
                                        type="password" 
                                        placeholder="Please enter your password" 
                                        required 
                                        maxLength={270} 
                                        ref={(c) => { this.passwordTextBox = c; }} />
                                </FormGroup>
                                <FormGroup>
                                    <Link to="/public/resetPassword">I need a new password</Link>
                                </FormGroup>
                                <FormGroup>
                                    <Row>
                                        <Col xs={6}>
                                        </Col>
                                        <Col xs={6} className="text-right">
                                            <Button id="btnSignIn" type="submit" bsStyle="primary">Login</Button>
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </Form>
                        </Col>
                    </Row>
                </Block.Block>
                <div className="text-center" >Version: {this.state.version} / {process.env.REACT_APP_ENV}</div>
            </React.Fragment>
        );
    }
}

export default CompleteLogin;



// WEBPACK FOOTER //
// ./src/areas/public/login/CompleteLogin.js